import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  container: {
    width: 800,
    minHeight: 500,
    maxHeight: 1000,
  },
}));
